import { isObjectLike as e } from "@scalar/helpers/object/is-object";
import { deSerializeParameter as t, filterDisabledProperties as n, getExampleFromSchema as r, isParamDisabled as i, serializeContentValue as a, serializeCookieStyle as o, serializeDeepObjectStyle as s, serializeFormStyle as c, serializeFormStyleForCookies as l, serializePipeDelimitedStyle as u, serializeSimpleStyle as d, serializeSpaceDelimitedStyle as f } from "@scalar/workspace-store/request-example";
import { getResolvedRef as p } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getCookieSerializationError as m } from "@scalar/helpers/http/get-cookie-serialization-error";
import { assertReservedPathUrl as h, serializeReservedPathParameter as g } from "@scalar/workspace-store/helpers/encode-path-parameter";
import { getParameterExample as _ } from "@scalar/workspace-store/helpers/get-parameter-example";
import { getQuerystringParameter as v, serializeQuerystringParameter as y } from "@scalar/workspace-store/helpers/querystring-parameter";
//#region src/code-example/helpers/operation-to-har/process-parameters.ts
var b = class extends Error {}, x = (e) => (e ?? []).map((e) => p(e)).filter((e) => e !== void 0), S = (e) => "allowReserved" in e && e.allowReserved !== void 0 ? e.allowReserved : "schema" in e && e.schema && typeof e.schema == "object" && "allowReserved" in e.schema ? e.schema.allowReserved === !0 : !1, C = (e) => {
	if (e.in === "header") return {
		style: "simple",
		explode: "explode" in e && e.explode !== void 0 && e.explode
	};
	if (e.in === "cookie") {
		let t = "explode" in e && e.explode !== void 0 ? e.explode : !0;
		return {
			style: "style" in e && e.style === "cookie" ? "cookie" : "form",
			explode: t
		};
	}
	let t = {
		path: "simple",
		query: "form",
		querystring: "form",
		header: "simple",
		cookie: "form"
	}[e.in], n = "style" in e && e.style ? e.style : t;
	return {
		style: n,
		explode: "explode" in e && e.explode !== void 0 ? e.explode : n === "form"
	};
}, w = (e, a, o) => {
	let s = _(e, a), c = s.example, l = e.in === "query" && !s.serialized && !s.mediaSerialized ? c?.["x-scalar-disabled-properties"] : void 0;
	if (l) return n(t(s.value, e), l, i(e, c, o));
	if (i(e, c, o)) return;
	if (s.value !== void 0) return t(s.value, e);
	if (!("schema" in e) || !e.schema) return;
	let u = e.in === "path" ? { emptyString: `{${e.name}}` } : {}, d = p(e.schema);
	return d ? r(d, u) : void 0;
}, T = ({ harRequest: e, parameters: t, example: n, defaultDisabled: r, openapiVersion: p }) => {
	let T = [...e.headers], D = [...e.queryString], O = [...e.cookies], k = [], A = e.url, j = !1, M = [], N = [], P = (e, t, n) => {
		S(n) ? M.push(`${encodeURIComponent(e)}=${t}`) : D.push({
			name: e,
			value: t
		});
	}, F = x(t);
	for (let e of F) {
		if (!e.in || !e.name) continue;
		if (e.in === "querystring") {
			let t = v(e, n, { defaultDisabled: r });
			if (t) {
				let e = A.indexOf("#"), n = e === -1 ? "" : A.slice(e), r = (e === -1 ? A : A.slice(0, e)).split("?")[0], i = y(t);
				A = `${r}${i ? `?${i}` : ""}${n}`;
			}
			continue;
		}
		let t = _(e, n);
		if (t.serialized && !i(e, t.example, r)) {
			let n = String(t.value);
			switch (e.in) {
				case "path":
					A = A.replaceAll(`{${e.name}}`, () => n);
					break;
				case "query":
					M.push(n);
					break;
				case "header":
					T.push({
						name: e.name,
						value: n
					});
					break;
				case "cookie": N.push(n);
			}
			continue;
		}
		if (t.mediaSerialized && !i(e, t.example, r)) {
			let n = String(t.value);
			switch (e.in) {
				case "query":
					P(e.name, n, e);
					break;
				case "header":
					T.push({
						name: e.name,
						value: n
					});
					break;
				case "path":
					A = A.replaceAll(`{${e.name}}`, () => encodeURIComponent(n));
					break;
				case "cookie": O.push({
					name: e.name,
					value: n
				});
			}
			continue;
		}
		let h = w(e, n, r);
		if (h === void 0) continue;
		let { style: x, explode: S } = C(e);
		switch (e.in) {
			case "path": {
				let t = p?.startsWith("3.2.") && "schema" in e && e.allowReserved === !0;
				j ||= !!t;
				let n = t ? g(e.name, {
					value: h,
					style: x,
					explode: S
				}) : void 0;
				A = n === void 0 ? E(A, e, h, x, S) : A.replaceAll(`{${e.name}}`, () => n);
				break;
			}
			case "query":
				if ("content" in e && e.content) {
					let t = Object.keys(e.content)[0] ?? "application/json", n = a(h, t);
					P(e.name, n, e);
					break;
				}
				switch (x) {
					case "form": {
						let t = c(h, S);
						if (Array.isArray(t)) for (let n of t) P(n.key || e.name, String(n.value), e);
						else P(e.name, String(t), e);
						break;
					}
					case "spaceDelimited": {
						let t = f(h);
						P(e.name, t, e);
						break;
					}
					case "pipeDelimited": {
						let t = u(h);
						P(e.name, t, e);
						break;
					}
					case "deepObject":
						if (Array.isArray(h)) {
							let t = c(h, !0);
							if (Array.isArray(t)) for (let n of t) P(n.key || e.name, String(n.value), e);
							else P(e.name, String(t), e);
						} else {
							let t = s(e.name, h);
							for (let n of t) P(n.key, n.value, e);
						}
						break;
					default: P(e.name, String(h), e);
				}
				break;
			case "header": {
				let t = d(h, S);
				T.push({
					name: e.name,
					value: String(t)
				});
				break;
			}
			case "cookie": {
				let [t, n] = (p ?? "").split("."), r = t === "3" && n === "2" && !("content" in e) ? m(e, h) : void 0;
				if (r) throw new b(r);
				if (x === "cookie") {
					k.push(...o(e.name, h, S));
					break;
				}
				let i = l(h, S);
				if (Array.isArray(i)) for (let t of i) {
					let n = t.key || e.name, r = t.value === null ? "null" : String(t.value);
					O.push({
						name: n,
						value: r
					});
				}
				else {
					let t = i === null ? "null" : String(i);
					O.push({
						name: e.name,
						value: t
					});
				}
				break;
			}
		}
	}
	if (k.length || N.length) {
		let e = [
			...O.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`),
			...k.map((e) => `${e.name}=${e.value}`),
			...N
		].join("; "), t = T.find((e) => e.name.toLowerCase() === "cookie");
		t ? T.splice(T.indexOf(t), 1, {
			...t,
			value: t.value ? `${t.value}; ${e}` : e
		}) : T.push({
			name: "Cookie",
			value: e
		});
	}
	if (M.length) {
		let e = A.indexOf("#"), t = e < 0 ? "" : A.slice(e), n = e < 0 ? A : A.slice(0, e);
		A = `${n}${n.includes("?") ? "&" : "?"}${M.join("&")}${t}`;
	}
	return j && h(A), {
		url: A,
		headers: T,
		queryString: D,
		cookies: k.length || N.length ? [] : O,
		hasCookieStyleEntries: k.length > 0 || N.length > 0,
		...M.length ? { hasSerializedQuery: !0 } : {}
	};
}, E = (t, n, r, i, a) => {
	switch (i) {
		case "matrix":
			if (a) {
				if (Array.isArray(r)) {
					let e = r.map((e) => `${n.name}=${e}`).join(";");
					return t.replace(`{;${n.name}}`, `;${e}`);
				}
				if (e(r)) {
					let e = Object.entries(r).map(([e, t]) => `${e}=${t}`).join(";");
					return t.replace(`{;${n.name}}`, `;${e}`);
				}
				return t.replace(`{;${n.name}}`, `;${n.name}=${r}`);
			}
			if (Array.isArray(r)) return t.replace(`{;${n.name}}`, `;${n.name}=${r.join(",")}`);
			if (e(r)) {
				let e = Object.entries(r).map(([e, t]) => `${e},${t}`).join(",");
				return t.replace(`{;${n.name}}`, `;${n.name}=${e}`);
			}
			return t.replace(`{;${n.name}}`, `;${n.name}=${r}`);
		case "label":
			if (a) {
				if (Array.isArray(r)) return t.replace(`{.${n.name}}`, `.${r.join(".")}`);
				if (e(r)) {
					let e = Object.entries(r).map(([e, t]) => `${e}=${t}`).join(".");
					return t.replace(`{.${n.name}}`, `.${e}`);
				}
				return t.replace(`{.${n.name}}`, `.${r}`);
			}
			if (Array.isArray(r)) return t.replace(`{.${n.name}}`, `.${r.join(",")}`);
			if (e(r)) {
				let e = Object.entries(r).map(([e, t]) => `${e},${t}`).join(",");
				return t.replace(`{.${n.name}}`, `.${e}`);
			}
			return t.replace(`{.${n.name}}`, `.${r}`);
		case "simple": {
			let e = d(r, a);
			return t.replace(`{${n.name}}`, String(e));
		}
		default: return t.replace(`{${n.name}}`, String(r));
	}
};
//#endregion
export { b as CookieSerializationError, T as processParameters };

//# sourceMappingURL=process-parameters.js.map